<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="modal-title font-weight-bold">SWITCH CLASS</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- LOADER -->
        <div
          class="loader d-flex justify-content-center align-items-center my-4"
          v-if="class_options.length === 0"
        >
          <div class="avatar">
            <span
              class="icon-dotted-spinner flex-center font-25 border_grey_dark animate mr-3"
            ></span>
          </div>
          <div class="border_grey_dark font-14">Loading Classes ....</div>
        </div>
        <!-- LOADER -->

        <div v-else>
          <!-- SWITCH CLASS ROW COMPONENT -->
          <SwitchClassRow
            :class_id="Number(item.id)"
            :class_name="item.class_name"
            :selected="item.active"
            v-for="(item, index) in class_options"
            :key="index"
            @updateClass="updateActiveClass($event)"
          ></SwitchClassRow>
          <!-- SWITCH CLASS ROW COMPONENT -->
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import SwitchClassRow from "@/components/classComps/studentSideBar/SwitchClassRow";
import { setTimeout } from "timers";

export default {
  name: "SwitchClassModal",

  computed: {
    ...mapGetters(["classList", "getCurrentClass"]),
  },

  components: {
    Modal,
    SwitchClassRow,
  },

  mounted() {
    this.checkCLassListState();
  },

  data() {
    return {
      class_options: [],
    };
  },

  methods: {
    ...mapActions(["getSchoolClasses", "setCurrentClass"]),

    checkCLassListState() {
      if (this.classList.length > 0) this.populateClassData(this.classList);
      else this.fetchSchoolClasses();
    },

    fetchSchoolClasses() {
      this.getSchoolClasses()
        .then((response) => this.populateClassData(response.data))
        .catch((err) => console.log(err));
    },

    populateClassData(classData) {
      this.class_options = [];
      classData.map((class_level) => {
        class_level.classes.map((class_info) => {
          let class_obj = {};
          class_obj.id = Number(class_info.id);
          class_obj.class_name = class_info.class_name;
          class_obj.class_code = class_info.class_code;
          class_obj.active = false;

          this.class_options.push(class_obj);
        });
      });
      this.getCurrentClassId();
    },

    getCurrentClassId() {
      if (this.getCurrentClass) {
        this.updateActiveClass(this.getCurrentClass, false);
      } else {
        this.updateActiveClass(this.options[0].id, false);
      }
    },

    updateActiveClass(class_id, close = true) {
      let class_index = this.class_options.findIndex(
        (val) => Number(class_id) === Number(val.id)
      ); //GET PREVIOUS SELECTED INDEX
      this.class_options.forEach((item) => (item.active = false)); //RESET CLASS ACTIVE TO FALSE
      this.class_options[class_index].active = true;

      // UPDATE CURRENT CLASS ID AND CLASS IN STATE
      this.$store.commit("SET_CLASS_ID", class_id);
      let currentClass = this.class_options.find((item) => item.id == class_id);
      this.$store.commit("SET_CURRENT_CLASS", currentClass); // find class and push into the store

      if (close) {
        setTimeout(() => {
          this.$emit("remountMembersCard");
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  @include breakpoint_max(sm) {
    font-size: 12.5px !important;
  }
}
</style>
